import type { UseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'

import * as ExploreKeys from '../reactQueryKeys/explore'

import { EmptyArray } from 'lib/array/arrayUtils'
import type { ExploreParams } from 'tripPlanner/api/explore'
import { getExploreItems } from 'tripPlanner/api/explore'
import type {
  GetExploreItemsError,
  GetExploreItemsResponse,
} from 'tripPlanner/api/explore/types'
import type { ExploreItem } from 'tripPlanner/types/common'
import type { UseExploreItemsParams } from './exploreParams'

const MINUTES = 60 * 1000
const HOURS = 60 * MINUTES
const STALE_TIME = 24 * HOURS

function paramsHaveQuery(
  params: UseExploreItemsParams,
): params is ExploreParams {
  return Boolean(params.query) && Boolean(params.locationBias)
}

export const useExploreItems = (
  params: UseExploreItemsParams,
  options?: UseQueryOptions<
    GetExploreItemsResponse['result'],
    GetExploreItemsError,
    Array<ExploreItem>
  >,
) => {
  return useQuery({
    queryKey: ExploreKeys.items(params),
    queryFn: () =>
      paramsHaveQuery(params) ?
          getExploreItems(params) :
          Promise.resolve({
            items: EmptyArray,
          }),
    staleTime: STALE_TIME,
    select: (data) => data.items,
    ...options,
  })
}
